/* eslint-disable class-methods-use-this */
import ReactGA from 'react-ga';
import _ from 'lodash';

// TODO: ported from legacy app, enable once users are supported
// const DIMENSIONS = {
//   'User Type': 'dimension2',
//   'User Status': 'dimension3'
// }

export const CONTENT_GROUPS: Record<string, any> = {
  default: 'contentGroup4',
};

export const ECOMMERCE_REVENUE = {
  clickOff: '0.98',
  lead: '5.50',
};

export interface EventProps {
  hitType?: string;
  category?: string;
  action?: string;
  label?: string | number[];
  value?: string;
  nonInteraction?: boolean;
}

export function event({
  hitType = 'event',
  category: eventCategory,
  action: eventAction,
  label: eventLabel,
  value: eventValue,
  nonInteraction = true,
}: EventProps): void {
  const eventParams = {
    hitType,
    eventCategory,
    eventAction,
    eventLabel,
    eventValue,
    nonInteraction,
  };

  ReactGA.ga('send', eventParams);
}

class GoogleAnalytics {
  constructor() {
    if (typeof window === 'undefined') {
      return;
    }

    ReactGA.initialize('UA-31147538-1');
    ReactGA.ga('require', 'displayfeatures');
    ReactGA.ga('require', 'ecommerce');
    ReactGA.ga('require', 'GTM-57BRCLS'); // Google Optimize container
    // TODO: ported from legacy app, enable once users are supported
    // this.setDimensions();
  }

  pageView(): void {
    ReactGA.ga('set', 'location', window.location.href);
    ReactGA.ga('send', 'pageview');
  }

  ecommerce({ id, revenue }: { id: number | string; revenue: string }): void {
    ReactGA.ga('ecommerce:addTransaction', { id, revenue });
    ReactGA.ga('ecommerce:send');
  }

  event(...args: Parameters<typeof event>): ReturnType<typeof event> {
    return event(...args);
  }

  // TODO: ported from legacy app, enable once users are supported
  // setDimensions() {
  //   const userStatus = AutoList.currentUser.isSignedIn() ? 'logged_in' : 'not_logged_in';
  //   const userType = AutoList.currentUser.isPaid() ? 'Paid' : 'Organic';

  //   ReactGA.ga('set', DIMENSIONS['User Status'], userStatus);
  //   ReactGA.ga('set', DIMENSIONS['User Type'], userType);

  //   return this;
  // },
}
export interface ContentGroups {
  default?: string | null | undefined;
  [key: string]: string | null | undefined;
}

export function setContentGroups(_groups: ContentGroups = {}): void {
  const groups = _groups;

  // Content groups that are not included should be set to null, this is to ensure that any
  // previously set groups are not unintentionally included in subsequent events. The only
  // way to unset a content group is to set it's value to null (no official documentation but it works)
  _.each(CONTENT_GROUPS, (gaGroupName, internalGroupName) => {
    if (!groups[internalGroupName]) {
      groups[internalGroupName] = null;
    }
  });

  _.each(groups, (category, group) => {
    ReactGA.ga('set', CONTENT_GROUPS[group], category);
  });
}

export default new GoogleAnalytics();
